import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import MailOutline from "@material-ui/icons/MailOutline";

// core components
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";

import { agentApi } from "functions/apis";
import ImpersonationRoleList from "./ImpersonationRoleList";
import ImpersonationPermissionList from "./ImpersonationPermissionList";
import ImpersonationAvailablePermissionList from "./ImpersonationAvailablePermissionList";
import { adminApi } from "functions/apis";

const useStyles = makeStyles(styles);

export default function ImpersonationDetail(props) {
  const impersonationDetailSignal = useRef(new AbortController());

  const { id } = useParams();
  const [impersonationData, setImpersonationData] = useState();
  const [userData, setUserData] = useState();
  const reloadHandler = () => {
    setReload({});
  };
  const [reload, setReload] = React.useState({});
  useEffect(() => {
    return () => impersonationDetailSignal.current.abort();
  }, []);

  useEffect(() => {
    fetchImpersonationData();
  }, [id, reload]);

  useEffect(() => {
    if (impersonationData) {
      getUserData();
    }
  }, [impersonationData]);

  const getUserData = () => {
    adminApi
      .get(`/Users/${impersonationData.userID}`, {
        signal: impersonationDetailSignal.current.signal
      })
      .then(data => setUserData(data))
      .catch(err => console.log(err));
  };

  const fetchImpersonationData = () => {
    agentApi
      .get(`/Impersonations/${id}`, {
        signal: impersonationDetailSignal.current.signal
      })
      .then(data => setImpersonationData(data))
      .catch(err => console.log(err));
  };

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>IMPERSONATION DETAIL</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <GridContainer>
              {userData && (
                <GridItem xs={12}>
                  <CustomInput
                    labelText="User"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: userData ? userData.userName : ""
                    }}
                  />
                </GridItem>
              )}
              <GridItem xs={12}>
                <CustomInput
                  labelText="Agent Code"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    disabled: true,
                    value: impersonationData ? impersonationData.agent.code : ""
                  }}
                />
              </GridItem>
              <GridItem xs={12}>
                <CustomInput
                  labelText="Agent Name"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    disabled: true,
                    value: impersonationData ? impersonationData.agent.name : ""
                  }}
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
        <ImpersonationRoleList id={id} />
        <GridContainer>
          <GridItem xs={6} sm={6} md={6}>
            <ImpersonationPermissionList
              id={id}
              reloadHandler={reloadHandler}
              reload={reload}
            />
          </GridItem>
          <GridItem xs={6} sm={6} md={6}>
            <ImpersonationAvailablePermissionList
              id={id}
              reloadHandler={reloadHandler}
              reload={reload}
            />
          </GridItem>
        </GridContainer>
      </GridItem>
    </GridContainer>
  );
}

ImpersonationDetail.propTypes = {
  history: PropTypes.object
};
